module.exports = __webpack_public_path__ + "static/img/1_3_2.d6c9d2b1.jpg";